export const getQueryParams = <T extends Record<string, string>>(): T => {
  const url = new URL(window.location.href);
  return Object.fromEntries(url.searchParams.entries()) as T;
};
